var map = {
	"./01-12-2020/Fowl.glb": "0588",
	"./03-12-2020/Fowl.glb": "6474",
	"./10-12-2020-v2/Fowl.glb": "fb3c",
	"./10-12-2020-v3/Fowl.glb": "51a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95c6";